import React, { FC, useState } from "react";

import { Card, CardBody, Col, Row, TabContent, TabPane } from "reactstrap";
import { Link } from "react-router-dom";

import ProfileTab1 from "./ProfilTab1";
import { useRecoilValue } from "recoil";
import { isLoggedInSelector } from "../../shared/actions/Authentication.actions";

const CustomerProfileDetail: FC = () => {
  document.title =
    "Profil Bilgisi | Bu ekranda profil bilgilerini görüntüleyebilirsiniz";

  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );
  const { profile, company } = useRecoilValue(isLoggedInSelector);

  const [activeTab, toggleTab] = useState("1");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);

  const toggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleDelete = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  const toggleSettings = () => {
    // setIsHistoryModalOpen(!isHistoryModalOpen)
  };

  return (
    <React.Fragment>
      <Row>
        {/* <Col xl={9} lg={8}> */}
        <Col xl={12} lg={12}>
          <Card>
            <CardBody>
              <Row>
                <div className="col-sm order-2 order-sm-1">
                  <div className="d-flex align-items-start mt-3 mt-sm-0">
                    <div className="flex-shrink-0">
                      <div className="avatar-xl me-3">
                        <div
                          style={{ fontSize: 64 }}
                          className="avatar-title bg-light-subtle text-light font-size-64 m-0 rounded-circle"
                        >
                          <i className="bx bxs-user-circle"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <h5 className="font-size-16 mb-1">
                          {profile?.fullname}
                        </h5>
                        <p className="text-muted font-size-13">
                          {profile?.username}
                        </p>
                        <p className="text-muted font-size-13">
                          {profile?.email}
                        </p>

                        <div className="d-flex flex-wrap align-items-start gap-2 gap-lg-3 text-muted font-size-13">
                          <div>
                            <p className="text-muted font-size-13">
                              {profile?.phone_number}
                            </p>
                          </div>
                        </div>

                        <div className="d-flex flex-wrap align-items-start gap-2 gap-lg-3 text-muted font-size-13">
                          <div>
                            <p className="text-muted font-size-13">
                              {company?.name}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-auto order-1 order-sm-2">
                  <div className="d-flex align-items-start justify-content-between gap-2">
                    {/* <div>
                      <button
                        onClick={toggleSettings}
                        type="button"
                        className="btn btn-soft-light"
                      >
                        <i className="bx bx-cog me-1"></i>
                      </button>
                    </div> */}

                    {/* <div>
                      <button
                        onClick={toggleDelete}
                        type="button"
                        className="btn btn-soft-danger"
                      >
                        <i className="bx bx-trash me-1"></i>
                      </button>
                    </div> */}
                  </div>
                </div>
              </Row>
            </CardBody>
          </Card>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <ProfileTab1 />
            </TabPane>
          </TabContent>
        </Col>
        {/* <Col xl={3} lg={4}>
          <Card>
            <CardBody>
              <h5 className="mb-3 card-title">Skills</h5>

              <div className="d-flex flex-wrap gap-2 font-size-16">
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  Photoshop
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  illustrator
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  HTML
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  CSS
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  Javascript
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  Php
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  Python
                </Link>
              </div>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <h5 className="mb-3 card-title">Portfolio</h5>

              <div>
                <ul className="list-unstyled mb-0">
                  <li>
                    <Link to="#" className="py-2 d-block text-muted">
                      <i className="mdi mdi-web text-primary me-1"></i> Website
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="py-2 d-block text-muted">
                      <i className="mdi mdi-note-text-outline text-primary me-1"></i> Blog
                    </Link>
                  </li>
                </ul>
              </div>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <h5 className="mb-3 card-title">Similar Profiles</h5>

              <div className="list-group list-group-flush">
                <Link to="#" className="list-group-item list-group-item-action">
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0 me-3">
                      <img src={avatar1} alt="" className="img-thumbnail rounded-circle" />
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <h5 className="font-size-14 mb-1">James Nix</h5>
                        <p className="font-size-13 text-muted mb-0">Full Stack Developer</p>
                      </div>
                    </div>
                  </div>
                </Link>
                <Link to="#" className="list-group-item list-group-item-action">
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0 me-3">
                      <img src={avatar3} alt="" className="img-thumbnail rounded-circle" />
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <h5 className="font-size-14 mb-1">Darlene Smith</h5>
                        <p className="font-size-13 text-muted mb-0">UI/UX Designer</p>
                      </div>
                    </div>
                  </div>
                </Link>
                <Link to="#" className="list-group-item list-group-item-action">
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0 me-3">
                      <div className="avatar-title bg-light-subtle text-light rounded-circle font-size-22">
                        <i className="bx bxs-user-circle"></i>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <h5 className="font-size-14 mb-1">William Swift</h5>
                        <p className="font-size-13 text-muted mb-0">Backend Developer</p>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </CardBody>
          </Card>
        </Col> */}
      </Row>
    </React.Fragment>
  );
};

export default CustomerProfileDetail;
